/**
 * Controls the use of buttons based on scroll position.
 * @param {HTMLElement} buttonElement - The button element to show or hide.
 * @param {number} positionY - Vertical scroll position.
 */

function scrollTopButton(buttonElement, positionY) {
  const BUTTON_SHOW_VALUE = 400;
  const BUTTON_STATE_CLASS = 'button-up--show';

  buttonElement.classList[positionY > BUTTON_SHOW_VALUE ? 'add' : 'remove'](BUTTON_STATE_CLASS);
}

export default scrollTopButton;